import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { IconsOptions } from 'projects/app-default/src/app/styles/cms.config';
import { LabelPaneComponent } from 'projects/app-default/src/app/ui/display/label-pane/label-pane.component';

export namespace NProductViewFreeGift {
    export const BLOCK_ID = 'product-free-gift';

    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    export interface IBlockDataContent {
        copy: string;
        color?: string;
        icon?: string;
    }
}

@Component({
    selector: 'product-view-free-gift-bunner',
    templateUrl: './product-view-free-gift-bunner.html',
    standalone: true,
    imports: [LabelPaneComponent, NgStyle, NgClass, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductViewFreeGiftBunnnerComponent>({
    id: NProductViewFreeGift.BLOCK_ID,
    block: {
        url: NProductViewFreeGift.BLOCK_ID
    },
    name: 'Free gift information',
    description: 'Global block information about free gift',
    onDemandOnly: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-general',
            title: 'General'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'copy',
            title: 'Copy',
            default: 'Don’t forget your free gift',
            required: true
        },
        <NICmsContentField.IColorPickerField>{
            key: 'color',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Color'
        },
        <NICmsContentField.IChoiceField>{
            key: 'icon',
            type: NICmsContentField.EFieldType.choice,
            title: 'Icon',
            options: IconsOptions
        }
    ]
})
export class ProductViewFreeGiftBunnnerComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NProductViewFreeGift.IBlockDataContent;
}
